import Card from "components/card";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "../../../../api/axios";
import { TailSpin } from "react-loader-spinner";

const Registerform = () => {
  const [municipalities, setMunicipalities] = useState([]);
  const [municipalityValue, setMunicipalityValue] = useState("");

  const [neighborhood, setNeighborhood] = useState([]);
  const [neighborhoodValue, setNeighborhoodValue] = useState("");

  const [institucion, setInstitucion] = useState([]);
  const [institucionValue, setInstitucionValue] = useState("");

  const [role, setRoles] = useState([]);
  const [roleValue, setRoleValue] = useState("");

  const [loading, setLoading] = useState(true);
  const [registerLoading, setRegisterLoading] = useState(false);

  const storedToken = localStorage.getItem("token");
  let token = "Bearer " + storedToken.replace(/"/g, "");

  const headers = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    fetchCities();
    fetchInstitutions();
    setLoading(false);
  }, []);

  const fetchCities = async () => {
    const response = await axios.get("/api/municipalities", {
      headers: headers,
    });
    setMunicipalities(response.data);
  };

  const handleMunicipalityChange = (event) => {
    const selectedId = event.target.value;
    setMunicipalityValue(selectedId);
    fetchNeigborhoods(selectedId);
  };

  const fetchNeigborhoods = async (muniId) => {
    const response = await axios.get(`/api/neighborhoodbymuni/${muniId}`, {
      headers: headers,
    });
    setNeighborhood(response.data);
    setNeighborhoodValue("");
  };

  const handleNeighborhoodChange = (event) => {
    const selectedId = event.target.value;
    setNeighborhoodValue(selectedId);
  };

  const fetchInstitutions = async () => {
    const response = await axios.get("/api/Institutions", { headers: headers });

    const normalized = response.data.map((item) => ({
      key: item.key || item.id,
      value: item.value || item.name,
    }));
    setInstitucion(normalized);
  };

  const handleInstitutionsChange = (event) => {
    const name = event.target.value;
    setInstitucionValue(name);
    fetchRoles(name);
  };

  const fetchRoles = async (name) => {
    const response = await axios.get(`/api/roles?institution=${name}`, {
      headers: headers,
    });
    setRoles(response.data);
    setRoleValue("");
  };

  const handleRoleChange = (event) => {
    const selectedId = event.target.value;
    setRoleValue(selectedId);
  };

  const [emri, setEmri] = useState("");
  const [mbiemri, setMbiemri] = useState("");
  const [email, setEmail] = useState("");
  const [telefoni, setTelefoni] = useState("");

  const [nameError, setNameError] = useState("");
  const [surnameError, setSurnameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const validateName = () => {
    if (emri.length < 2) {
      setNameError("Emri duhet të ketë dy e më shumë shkronja!");
    } else if (/[^\p{L}]/u.test(emri)) {
      setNameError("Ju lutem shkruani vetëm shkronja!");
    } else {
      setNameError("");
    }
  };

  const validateSurname = () => {
    if (mbiemri.length < 2) {
      setSurnameError("Mbiemri duhet të ketë dy e më shumë shkronja!");
    } else if (/[^\p{L}]/u.test(mbiemri)) {
      setSurnameError("Ju lutem shkruani vetëm shkronja!");
    } else {
      setSurnameError("");
    }
  };

  const validateEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Emaili juaj nuk është në rregull!");
    } else {
      setEmailError("");
    }
  };

  const validatePhone = () => {
    if (telefoni.length < 9 || /\D/.test(telefoni)) {
      setPhoneError("Numri i telefonit mund të ketë nga 9 deri në 13 numra!");
    } else {
      setPhoneError("");
    }
  };

  const registerAdmin = async () => {
    // prevent double-click
    if (registerLoading) return;

    // quick validation
    if (emri.length < 2 || mbiemri.length < 2 || email.length < 5 || telefoni.length < 9) {
      Swal.fire({
        icon: "error",
        text: "Ju lutemi plotësoni të gjitha fushat saktë!",
        confirmButtonColor: "#18817d",
      });
      return;
    }

    const body = {
      firstName: emri,
      lastName: mbiemri,
      email: email,
      phoneNumber: telefoni,
      municipality: municipalityValue,
      neighborhood: neighborhoodValue,
      instition: institucionValue,
      role: roleValue,
    };

    try {
      setRegisterLoading(true);
      const res = await axios.post("/api/account/addadmin", body, { headers });

      if (res.data.status) {
        Swal.fire({
          icon: "success",
          text: res.data.message || "Administratori është regjistruar me sukses!",
          showConfirmButton: true,
          confirmButtonColor: "#18817d",
          confirmButtonText: "Mbyll",
          timer: 2500,
        });

        // setTimeout(() => {
        //   window.location.href = "/admin/dashboard";
        // }, 1000);

        setTimeout(() => {
          const userRole = localStorage.getItem("roles")?.toLowerCase();

          if (userRole?.includes("admin_police")) {
            window.location.href = "/admin/dashboard-police";
          } else {
            window.location.href = "/admin/dashboard";
          }
        }, 200);
      } else {
        Swal.fire({
          icon: "error",
          text: res.data.message || "Krijimi dështoi. Ju lutemi kontrolloni të dhënat.",
          confirmButtonColor: "#18817d",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: error.response?.data?.message || "Gabim gjatë regjistrimit.",
        confirmButtonColor: "#18817d",
      });
    } finally {
      setRegisterLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <div className="mt-11 flex items-center justify-center pt-11">
          <TailSpin height={70} width={70} color="#18817d" />
        </div>
      ) : (
        <Card extra={"items-center w-full h-full p-[16px] bg-cover"}>
          <div className="mt-[4vh] w-full flex-col items-center md:pl-4 lg:pl-0">
            {/* FORM START */}
            <div className="flex flex-wrap">
              <div className="mb-3 w-full md:w-1/2 md:pr-2">
                <label htmlFor="emri" className="dark:text-white">Emri</label>
                <input
                  placeholder="Shkruani emrin"
                  type="text"
                  className="mt-2 flex h-12 w-full rounded-xl border bg-white/0 p-3 text-sm outline-none dark:text-white"
                  value={emri}
                  onChange={(e) => setEmri(e.target.value)}
                  onBlur={validateName}
                />
                {nameError && <p className="text-red-500 text-sm">{nameError}</p>}
              </div>

              <div className="mb-3 w-full md:w-1/2 md:pr-2">
                <label htmlFor="mbiemri" className="dark:text-white">Mbiemri</label>
                <input
                  placeholder="Shkruani mbiemrin"
                  type="text"
                  className="mt-2 flex h-12 w-full rounded-xl border bg-white/0 p-3 text-sm outline-none dark:text-white"
                  value={mbiemri}
                  onChange={(e) => setMbiemri(e.target.value)}
                  onBlur={validateSurname}
                />
                {surnameError && <p className="text-red-500 text-sm">{surnameError}</p>}
              </div>
            </div>

            <div className="flex flex-wrap">
              <div className="mb-3 w-full md:w-1/2 md:pr-2">
                <label htmlFor="email" className="dark:text-white">Email</label>
                <input
                  placeholder="Shkruani emailin adresen"
                  type="email"
                  className="mt-2 flex h-12 w-full rounded-xl border bg-white/0 p-3 text-sm outline-none dark:text-white"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onBlur={validateEmail}
                />
                {emailError && <p className="text-red-500 text-sm">{emailError}</p>}
              </div>

              <div className="mb-3 w-full md:w-1/2 md:pr-2">
                <label htmlFor="phone" className="dark:text-white">Nr. telefonit</label>
                <input
                  placeholder="Shkruani numrin e telefonit"
                  type="number"
                  className="mt-2 flex h-12 w-full rounded-xl border bg-white/0 p-3 text-sm outline-none dark:text-white"
                  value={telefoni}
                  onChange={(e) => setTelefoni(e.target.value)}
                  onBlur={validatePhone}
                />
                {phoneError && <p className="text-red-500 text-sm">{phoneError}</p>}
              </div>
            </div>

            <div className="flex flex-wrap">
              <div className="mb-3 w-full md:w-1/2 md:pr-2">
                <label className="dark:text-white">Qyteti</label>
                <select
                  value={municipalityValue}
                  onChange={handleMunicipalityChange}
                  className="mt-2 flex h-12 w-full rounded-xl border bg-white/0 p-3 text-sm outline-none dark:text-white"
                >
                  <option value="" disabled>Zgjedh qytetin</option>
                  {municipalities.map((option) => (
                    <option key={option.id} value={option.id}>{option.name}</option>
                  ))}
                </select>
              </div>

              <div className="mb-3 w-full md:w-1/2 md:pr-2">
                <label className="dark:text-white">Lagjia</label>
                <select
                  value={neighborhoodValue}
                  onChange={handleNeighborhoodChange}
                  className="mt-2 flex h-12 w-full rounded-xl border bg-white/0 p-3 text-sm outline-none dark:text-white"
                >
                  <option value="" disabled>Zgjedh lagjen</option>
                  {neighborhood.map((option) => (
                    <option key={option.id} value={option.id}>{option.name}</option>
                  ))}
                </select>
              </div>
              <p className="text-sm text-gray-600 dark:text-white w-full">
                *Të dhënat e qytetit dhe lagjes duhet përshtatur varësisht nga vendi i punës
              </p>
            </div>

            <div className="flex flex-wrap pt-3">
              <div className="mb-3 w-full md:w-1/2 md:pr-2">
                <label className="dark:text-white">Institucioni</label>
                <select
                  value={institucionValue}
                  onChange={handleInstitutionsChange}
                  className="mt-2 flex h-12 w-full rounded-xl border bg-white/0 p-3 text-sm outline-none dark:text-white"
                >
                  <option value="" disabled>Zgjedh institucionin</option>
                  {institucion.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.value}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3 w-full md:w-1/2 md:pr-2">
                <label className="dark:text-white">Pozita</label>
                <select
                  value={roleValue}
                  onChange={handleRoleChange}
                  className="mt-2 flex h-12 w-full rounded-xl border bg-white/0 p-3 text-sm outline-none dark:text-white"
                >
                  <option value="" disabled>Zgjedh poziten</option>
                  {role.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                  ))}
                </select>
              </div>
            </div>

          <div className="flex justify-end pe-2 pt-4">
              <button
                onClick={registerAdmin}
                disabled={registerLoading}
                className={`linear mb-4 mt-2 w-full md:w-1/3 rounded-xl py-[12px] text-base font-medium text-white transition-all duration-200 flex items-center justify-center ${
                  registerLoading
                    ? "bg-brand-600 cursor-not-allowed opacity-80"
                    : "bg-brand-500 hover:bg-brand-600"
                }`}
              >
                {registerLoading ? (
                  <>
                    <TailSpin height={22} width={22} color="#fff" />
                    <span className="ml-2">Duke regjistruar...</span>
                  </>
                ) : (
                  "Regjistro"
                )}
              </button>
        </div>
          </div>
        </Card>
      )}
    </>
  );
};

export default Registerform;
